import { render } from "./PPromotion.vue?vue&type=template&id=76cc97d1&scoped=true"
import script from "./PPromotion.vue?vue&type=script&lang=js"
export * from "./PPromotion.vue?vue&type=script&lang=js"

import "./PPromotion.vue?vue&type=style&index=0&id=76cc97d1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76cc97d1"]])

export default __exports__